import { HdAPI } from './types'
import queryString from 'query-string'

export const hdApi: HdAPI = ky => {
  return {
    async fetch({ patientId, cursor, currentTab }) {
      return ky(`patient/${patientId}/hd/`, {
        method: 'get',
        searchParams: queryString.stringify({ cursor, currentTab })
      }).json()
    },

    async update({ patientId, hdId, payload }) {
      return await ky(`patient/${patientId}/hd/${hdId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/hd/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async fetchSetting({ patientId }) {
      return ky(`patient/${patientId}/hd_setting/`, {
        method: 'get'
      }).json()
    },

    async createSetting({ patientId, payload }) {
      return ky(`patient/${patientId}/hd_setting/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
